type AcceptKeyEvent = Pick<
  KeyboardEvent,
  'key' | 'shiftKey' | 'ctrlKey' | 'altKey' | 'metaKey'
>;

type ImeKeyEvent = Pick<KeyboardEvent, 'isComposing' | 'keyCode'>;

// Lowercasing can change a string's length ('İ' becomes two code units), so
// the comparison is between same-length slices of the original strings and
// the remainder always comes from the untouched suggestion.
export const getGhostCompletion = (
  value: string,
  suggestion?: string
): string => {
  if (!suggestion || value.trim() === '' || suggestion.length <= value.length) {
    return '';
  }
  if (suggestion.slice(0, value.length).toLowerCase() !== value.toLowerCase()) {
    return '';
  }
  return suggestion.slice(value.length);
};

export const isGhostAcceptKey = (
  event: AcceptKeyEvent,
  caretAtEnd: boolean
): boolean => {
  if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) {
    return false;
  }
  if (event.key === 'Tab') {
    return true;
  }
  if (event.key === 'ArrowRight') {
    return caretAtEnd;
  }
  return false;
};

// Safari fires the keydown that commits a composition with isComposing false
// but keyCode 229, so both are needed to keep IME candidate keys untouched.
export const isImeKeyEvent = (event: ImeKeyEvent): boolean =>
  event.isComposing || event.keyCode === 229;
